import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface ReactivationOffer {
  id: string;
  merchantId: string;
  offerType: string;
  status: string;
  expiresAt: string | null;
  claimedAt: string | null;
  createdAt: string;
  stripeCouponId: string | null;
  previousPlanId: string | null;
  description?: string;
}

export interface ClaimOfferResponse {
  success: boolean;
  checkoutUrl?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OffersService {
  private readonly apiUrl = `${environment.apiUrl}/offers`;

  constructor(private readonly http: HttpClient) {}

  getPendingOffer(): Observable<ReactivationOffer | null> {
    return this.http
      .get<{ offer: ReactivationOffer | null }>(`${this.apiUrl}/pending`)
      .pipe(map(res => res.offer));
  }

  /**
   * Claim a pending reactivation offer.
   *
   * @param offerType   The pending offer's type.
   * @param targetPlanId Optional plan the merchant picked in the cabinet's plan
   *   picker (Feature 2A). When omitted the backend falls back to the offer's
   *   `previousPlanId` (fully backward-compatible plain Claim). The backend
   *   re-validates the target server-side (paid, MONTH|YEAR, category/agency
   *   compatible) — the picker is not a security boundary.
   */
  claimOffer(offerType: string, targetPlanId?: string): Observable<ClaimOfferResponse> {
    const body: { offerType: string; targetPlanId?: string } = { offerType };
    if (targetPlanId) {
      body.targetPlanId = targetPlanId;
    }
    return this.http.post<ClaimOfferResponse>(`${this.apiUrl}/claim`, body);
  }

  dismissOffer(offerId: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.apiUrl}/dismiss/${offerId}`, {});
  }
}
